import React from "react";
import { CalendarCheck, Zap, ShieldCheck } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

const ICONS = [CalendarCheck, Zap, ShieldCheck];

export const ReassuranceBadges = ({ className = "" }) => {
  const { t } = useI18n();
  const items = t("reassurance.items");
  if (!Array.isArray(items)) return null;
  return (
    <div className={`flex flex-col gap-2.5 ${className}`} data-testid="reassurance-badges">
      {items.map((label, i) => {
        const Icon = ICONS[i % ICONS.length];
        return (
          <div key={label} className="flex items-center gap-2.5 text-xs text-ink-600" data-testid={`reassurance-badge-${i}`}>
            <span className="flex items-center justify-center w-7 h-7 rounded-full bg-brand-50 text-brand shrink-0">
              <Icon size={15} strokeWidth={1.8} />
            </span>
            <span className="font-body">{label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ReassuranceBadges;
